var items = {
  "block.minecraft.air": "sail blower",
  "block.minecraft.stone": "rock",
  "block.minecraft.granite": "brown pebbles",
  "block.minecraft.polished_granite": "good lookin' brown pebbles",
  "block.minecraft.diorite": "white pebbles",
  "block.minecraft.polished_diorite": "good lookin' white pebbles",
  "block.minecraft.andesite": "gray pebbles",
  "block.minecraft.polished_andesite": "good lookin' gray pebbles",
  "block.minecraft.grass_block": "chunk o' grass",
  "block.minecraft.dirt": "filth",
  "block.minecraft.coarse_dirt": "rough filth",
  "block.minecraft.podzol": "pine straw",
  "block.minecraft.crimson_nylium": "red moss o' eerie",
  "block.minecraft.warped_nylium": "moss o' twistin'",
  "block.minecraft.cobblestone": "pebbles",
  "block.minecraft.oak_planks": "planks o' oak",
  "block.minecraft.spruce_planks": "planks o' spruce",
  "block.minecraft.birch_planks": "planks o' birch",
  "block.minecraft.jungle_planks": "planks o' jungle",
  "block.minecraft.acacia_planks": "planks o' acacia",
  "block.minecraft.dark_oak_planks": "planks o' dusky oak",
  "block.minecraft.crimson_planks": "planks o' ichor",
  "block.minecraft.warped_planks": "twist'd wood",
  "block.minecraft.oak_sapling": "oak meager shrub",
  "block.minecraft.spruce_sapling": "spruce meager shrub",
  "block.minecraft.birch_sapling": "birch meager shrub",
  "block.minecraft.jungle_sapling": "jungle meager shrub",
  "block.minecraft.acacia_sapling": "acacia meager shrub",
  "block.minecraft.dark_oak_sapling": "dusky oak meager shrub",
  "block.minecraft.bedrock": "the har'est rock",
  "block.minecraft.sand": "sand",
  "block.minecraft.red_sand": "scarlet sand",
  "block.minecraft.gravel": "rubble",
  "block.minecraft.gold_ore": "orrre o' gold",
  "block.minecraft.iron_ore": "orrre o' steel",
  "block.minecraft.coal_ore": "orrre o' fuel",
  "block.minecraft.nether_gold_ore": "devil's buried treasure",
  "block.minecraft.oak_log": "log o' oak",
  "block.minecraft.spruce_log": "log o' spruce",
  "block.minecraft.birch_log": "log o' birch",
  "block.minecraft.jungle_log": "log o' jungle",
  "block.minecraft.acacia_log": "log o' acacia",
  "block.minecraft.dark_oak_log": "log o' dusky oak",
  "block.minecraft.crimson_stem": "stem o' horror",
  "block.minecraft.warped_stem": "warpin' stem",
  "block.minecraft.stripped_oak_log": "bare log o' oak",
  "block.minecraft.stripped_spruce_log": "bare log o' spruce",
  "block.minecraft.stripped_birch_log": "bare log o' birch",
  "block.minecraft.stripped_jungle_log": "bare log o' jungle",
  "block.minecraft.stripped_acacia_log": "bare log o' acacia",
  "block.minecraft.stripped_dark_oak_log": "bare log o' dusky oak",
  "block.minecraft.stripped_crimson_stem": "bare stem o' horror",
  "block.minecraft.stripped_warped_stem": "stripped warpin' stem",
  "block.minecraft.stripped_oak_wood": "bare oak timber",
  "block.minecraft.stripped_spruce_wood": "bare spruce timber",
  "block.minecraft.stripped_birch_wood": "bare birch timber",
  "block.minecraft.stripped_jungle_wood": "bare jungle timber",
  "block.minecraft.stripped_acacia_wood": "bare acacia timber",
  "block.minecraft.stripped_dark_oak_wood": "bare dusky oak timber",
  "block.minecraft.stripped_crimson_hyphae": "stripped red strings o' woe",
  "block.minecraft.stripped_warped_hyphae": "skinned strings o' sorrow",
  "block.minecraft.oak_wood": "oak timber",
  "block.minecraft.spruce_wood": "spruce timber",
  "block.minecraft.birch_wood": "birch timber",
  "block.minecraft.jungle_wood": "jungle timber",
  "block.minecraft.acacia_wood": "acacia timber",
  "block.minecraft.dark_oak_wood": "dusky oak timber",
  "block.minecraft.crimson_hyphae": "red strings o' woe",
  "block.minecraft.warped_hyphae": "twisted strings",
  "block.minecraft.oak_leaves": "leaves o' oak",
  "block.minecraft.spruce_leaves": "leaves o' spruce",
  "block.minecraft.birch_leaves": "leaves o' birch",
  "block.minecraft.jungle_leaves": "leaves o' jungle",
  "block.minecraft.acacia_leaves": "leaves o' acacia",
  "block.minecraft.dark_oak_leaves": "leaves o' dusky oak",
  "block.minecraft.sponge": "sponge",
  "block.minecraft.wet_sponge": "watery sponge",
  "block.minecraft.glass": "porthole",
  "block.minecraft.lapis_ore": "orrre o' lāzhward",
  "block.minecraft.lapis_block": "chunk o' lāzhward",
  "block.minecraft.dispenser": "cannon",
  "block.minecraft.sandstone": "stone o' sands",
  "block.minecraft.chiseled_sandstone": "carv'd stone o' sands",
  "block.minecraft.cut_sandstone": "cut stone o' sands",
  "block.minecraft.note_block": "hornpipe",
  "block.minecraft.powered_rail": "boost track",
  "block.minecraft.detector_rail": "magic track",
  "block.minecraft.sticky_piston": "piston o' slime",
  "block.minecraft.cobweb": "web o' spider",
  "block.minecraft.grass": "grass",
  "block.minecraft.fern": "jungle plant",
  "block.minecraft.dead_bush": "unfortunate sight o' leaves",
  "block.minecraft.seagrass": "grass o' sea",
  "block.minecraft.sea_pickle": "salty sea pickle",
  "block.minecraft.piston": "raised deck",
  "block.minecraft.white_wool": "white cloth",
  "block.minecraft.orange_wool": "orange cloth",
  "block.minecraft.magenta_wool": "light purple cloth",
  "block.minecraft.light_blue_wool": "light blue cloth",
  "block.minecraft.yellow_wool": "yellow cloth",
  "block.minecraft.lime_wool": "light green cloth",
  "block.minecraft.pink_wool": "pink cloth",
  "block.minecraft.gray_wool": "gray cloth",
  "block.minecraft.light_gray_wool": "light gray cloth",
  "block.minecraft.cyan_wool": "ocean blue cloth",
  "block.minecraft.purple_wool": "purple cloth",
  "block.minecraft.blue_wool": "blue cloth",
  "block.minecraft.brown_wool": "brown cloth",
  "block.minecraft.green_wool": "green cloth",
  "block.minecraft.red_wool": "scarlet cloth",
  "block.minecraft.black_wool": "black cloth",
  "block.minecraft.dandelion": "yellow flower",
  "block.minecraft.poppy": "scarlet flower",
  "block.minecraft.blue_orchid": "beauty o' the swamps",
  "block.minecraft.allium": "pink fluff",
  "block.minecraft.azure_bluet": "blue flower",
  "block.minecraft.red_tulip": "scarlet tulip",
  "block.minecraft.orange_tulip": "orange tulip",
  "block.minecraft.white_tulip": "white tulip",
  "block.minecraft.pink_tulip": "pink tulip",
  "block.minecraft.oxeye_daisy": "daisy fl'er",
  "block.minecraft.cornflower": "cornflowarrr",
  "block.minecraft.lily_of_the_valley": "pretty poison",
  "block.minecraft.wither_rose": "wither blossom",
  "block.minecraft.brown_mushroom": "brown shroom",
  "block.minecraft.red_mushroom": "scarlet 'shroom",
  "block.minecraft.crimson_fungus": "fungus o' ichor",
  "block.minecraft.warped_fungus": "fungus o' unearthly",
  "block.minecraft.crimson_roots": "tendrils o' ichor",
  "block.minecraft.warped_roots": "nonsensical grass o' gloom",
  "block.minecraft.nether_sprouts": "weeds o' damnation",
  "block.minecraft.weeping_vines": "green string o' sobbin'",
  "block.minecraft.twisting_vines": "green vines o' swirlin'",
  "block.minecraft.sugar_cane": "sugar reed",
  "block.minecraft.kelp": "sea lettuce",
  "block.minecraft.bamboo": "bambarrr",
  "block.minecraft.gold_block": "chunk o' gold",
  "block.minecraft.iron_block": "chunk o' steel",
  "block.minecraft.oak_slab": "slab o' oak",
  "block.minecraft.spruce_slab": "slab o' spruce",
  "block.minecraft.birch_slab": "slab o' birch",
  "block.minecraft.jungle_slab": "slab o' jungle",
  "block.minecraft.acacia_slab": "slab o' acacia",
  "block.minecraft.dark_oak_slab": "slab o' dusky oak",
  "block.minecraft.crimson_slab": "slab o' ichor",
  "block.minecraft.warped_slab": "bizzare slab o' hyphae",
  "block.minecraft.stone_slab": "slab o' rock",
  "block.minecraft.smooth_stone_slab": "slab o' smoot'ened rock",
  "block.minecraft.sandstone_slab": "slab o' stone o' sands",
  "block.minecraft.cut_sandstone_slab": "cut slab o' stone o' sands",
  "block.minecraft.petrified_oak_slab": "slab o' petrified oak",
  "block.minecraft.cobblestone_slab": "slab o' pebbles",
  "block.minecraft.brick_slab": "slab o' brick",
  "block.minecraft.stone_brick_slab": "slab o' bricks o' rock",
  "block.minecraft.nether_brick_slab": "slab o' brick o' nether",
  "block.minecraft.quartz_slab": "slab o' white rock",
  "block.minecraft.red_sandstone_slab": "slab o' scarlet stone o' sands",
  "block.minecraft.cut_red_sandstone_slab": "cut slab o' scarlet stone o' sands",
  "block.minecraft.purpur_slab": "slab o' purpur",
  "block.minecraft.prismarine_slab": "slab o' prismarine",
  "block.minecraft.prismarine_brick_slab": "brick slab o' prismarine",
  "block.minecraft.dark_prismarine_slab": "slab o' dusky prismarine",
  "block.minecraft.smooth_quartz": "chunk o' smooth white rock",
  "block.minecraft.smooth_red_sandstone": "smooth scarlet sandstone",
  "block.minecraft.smooth_sandstone": "smooth stone o' sands",
  "block.minecraft.smooth_stone": "smoot'ened rock",
  "block.minecraft.bricks": "bricks o' clay",
  "block.minecraft.tnt": "powder keg",
  "block.minecraft.bookshelf": "stack o' knowledge",
  "block.minecraft.mossy_cobblestone": "slimy pebbles",
  "block.minecraft.obsidian": "rock o' tears",
  "block.minecraft.torch": "torch",
  "block.minecraft.end_rod": "end wand",
  "block.minecraft.chorus_plant": "tall one's tree",
  "block.minecraft.chorus_flower": "tall one's flower",
  "block.minecraft.purpur_block": "block o' purpur",
  "block.minecraft.purpur_pillar": "post o' purpur",
  "block.minecraft.purpur_stairs": "stairs o' purpur",
  "block.minecraft.spawner": "cage o' demons",
  "block.minecraft.oak_stairs": "stairs o' oak",
  "block.minecraft.chest": "coffer",
  "block.minecraft.diamond_ore": "orrre o' diamond",
  "block.minecraft.diamond_block": "chunk o' diamond",
  "block.minecraft.crafting_table": "craftin' table",
  "block.minecraft.farmland": "fertile land",
  "block.minecraft.furnace": "oven",
  "block.minecraft.ladder": "riggin'",
  "block.minecraft.rail": "track",
  "block.minecraft.cobblestone_stairs": "stairs o' pebbles",
  "block.minecraft.lever": "leverrr",
  "block.minecraft.stone_pressure_plate": "booby trap o' rock",
  "block.minecraft.oak_pressure_plate": "booby trap o' oak",
  "block.minecraft.spruce_pressure_plate": "booby trap o' spruce",
  "block.minecraft.birch_pressure_plate": "booby trap o' birch",
  "block.minecraft.jungle_pressure_plate": "booby trap o' jungle",
  "block.minecraft.acacia_pressure_plate": "booby trap o' acacia",
  "block.minecraft.dark_oak_pressure_plate": "booby trap o' dusky oak",
  "block.minecraft.crimson_pressure_plate": "booby trap o' ichor",
  "block.minecraft.warped_pressure_plate": "twisted booby trap",
  "block.minecraft.polished_blackstone_pressure_plate": "booby trap o' good lookin' black rock",
  "block.minecraft.redstone_ore": "orrre o' redstone",
  "block.minecraft.redstone_torch": "redstone torch",
  "block.minecraft.snow": "slush",
  "block.minecraft.ice": "frost",
  "block.minecraft.snow_block": "block o' snow",
  "block.minecraft.cactus": "cactus",
  "block.minecraft.clay": "solid mud",
  "block.minecraft.jukebox": "barrel organ",
  "block.minecraft.oak_fence": "picket o' oak",
  "block.minecraft.spruce_fence": "picket o' spruce",
  "block.minecraft.birch_fence": "picket o' birch",
  "block.minecraft.jungle_fence": "picket o' jungle",
  "block.minecraft.acacia_fence": "picket o' acacia",
  "block.minecraft.dark_oak_fence": "picket o' dusky oak",
  "block.minecraft.crimson_fence": "picket o' ichor",
  "block.minecraft.warped_fence": "odd fence o' hyphae",
  "block.minecraft.pumpkin": "gourd squash",
  "block.minecraft.carved_pumpkin": "carv'd gourd squash",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "sand o' the devil",
  "block.minecraft.soul_soil": "mud o' th' dead",
  "block.minecraft.basalt": "rock o' magma",
  "block.minecraft.polished_basalt": "good lookin' rock o' magma",
  "block.minecraft.soul_torch": "spirit torch",
  "block.minecraft.glowstone": "glowstone",
  "block.minecraft.jack_o_lantern": "jack o'lantern",
  "block.minecraft.oak_trapdoor": "hatch o' oak",
  "block.minecraft.spruce_trapdoor": "hatch o' spruce",
  "block.minecraft.birch_trapdoor": "hatch o' birch",
  "block.minecraft.jungle_trapdoor": "hatch o' jungle",
  "block.minecraft.acacia_trapdoor": "hatch o' acacia",
  "block.minecraft.dark_oak_trapdoor": "hatch o' dusky oak",
  "block.minecraft.crimson_trapdoor": "hatch o' ichor",
  "block.minecraft.warped_trapdoor": "peculiar hatch o' hyphae",
  "block.minecraft.infested_stone": "inhabited rock",
  "block.minecraft.infested_cobblestone": "inhabited pebbles",
  "block.minecraft.infested_stone_bricks": "inhabited bricks o' rock",
  "block.minecraft.infested_mossy_stone_bricks": "inhabited slimy bricks o' rock",
  "block.minecraft.infested_cracked_stone_bricks": "inhabited cracked bricks o' rock",
  "block.minecraft.infested_chiseled_stone_bricks": "inhabited carv'd bricks o' rock",
  "block.minecraft.stone_bricks": "bricks o' rock",
  "block.minecraft.mossy_stone_bricks": "slimy bricks o' rock",
  "block.minecraft.cracked_stone_bricks": "cracked bricks o' rock",
  "block.minecraft.chiseled_stone_bricks": "carv'd bricks o' rock",
  "block.minecraft.brown_mushroom_block": "tarnish'd 'shroom block",
  "block.minecraft.red_mushroom_block": "scarlet 'shroom block",
  "block.minecraft.mushroom_stem": "stem o' 'shroom",
  "block.minecraft.iron_bars": "barrrs o' steel",
  "block.minecraft.chain": "followin'",
  "block.minecraft.glass_pane": "porthole",
  "block.minecraft.melon": "watermel'n",
  "block.minecraft.vine": "swingers",
  "block.minecraft.oak_fence_gate": "picket gate o' oak",
  "block.minecraft.spruce_fence_gate": "picket gate o' spruce",
  "block.minecraft.birch_fence_gate": "picket gate o' birch",
  "block.minecraft.jungle_fence_gate": "picket gate o' jungle",
  "block.minecraft.acacia_fence_gate": "picket gate o' acacia",
  "block.minecraft.dark_oak_fence_gate": "picket gate o' dusky oak",
  "block.minecraft.crimson_fence_gate": "picket gate o' ichor",
  "block.minecraft.warped_fence_gate": "outlandish fence gate o' hyphae",
  "block.minecraft.brick_stairs": "stairs o' brick o' clay",
  "block.minecraft.stone_brick_stairs": "stairs o' bricks o' rock",
  "block.minecraft.mycelium": "rottin' spores",
  "block.minecraft.lily_pad": "pond plant",
  "block.minecraft.nether_bricks": "bricks o' nether",
  "block.minecraft.cracked_nether_bricks": "cracked bricks o' wickedness",
  "block.minecraft.chiseled_nether_bricks": "polished bricks o' vileness",
  "block.minecraft.nether_brick_fence": "picket o' nether",
  "block.minecraft.nether_brick_stairs": "stairs o' brick o' nether",
  "block.minecraft.enchanting_table": "witchcraft bench",
  "block.minecraft.end_portal_frame": "end porthole holderrr",
  "block.minecraft.end_stone": "foreign stone",
  "block.minecraft.end_stone_bricks": "foreign stone bricks",
  "block.minecraft.dragon_egg": "wyvern's last treasure",
  "block.minecraft.redstone_lamp": "redstone lanterrrn",
  "block.minecraft.sandstone_stairs": "stairs o' stone o' sands",
  "block.minecraft.emerald_ore": "orrre o' emerald",
  "block.minecraft.ender_chest": "ender coffer",
  "block.minecraft.tripwire_hook": "trippin' thread hook",
  "block.minecraft.emerald_block": "chunk o' emerald",
  "block.minecraft.spruce_stairs": "stairs o' spruce",
  "block.minecraft.birch_stairs": "stairs o' birch",
  "block.minecraft.jungle_stairs": "stairs o' jungle",
  "block.minecraft.crimson_stairs": "stairs o' ichor",
  "block.minecraft.warped_stairs": "mysterious stairs o' hyphae",
  "block.minecraft.command_block": "order block",
  "block.minecraft.beacon": "buoy o' light",
  "block.minecraft.cobblestone_wall": "wall o' pebbles",
  "block.minecraft.mossy_cobblestone_wall": "wall o' slimy pebbles",
  "block.minecraft.brick_wall": "wall o' bricks o' clay",
  "block.minecraft.prismarine_wall": "wall o' prismarine",
  "block.minecraft.red_sandstone_wall": "wall o' scarlet stone o' sands",
  "block.minecraft.mossy_stone_brick_wall": "wall o' slimy bricks o' stone",
  "block.minecraft.granite_wall": "wall o' brown pebbles",
  "block.minecraft.stone_brick_wall": "wall o' bricks o' rock",
  "block.minecraft.nether_brick_wall": "wall o' bricks o' nether",
  "block.minecraft.andesite_wall": "wall o' gray pebbles",
  "block.minecraft.red_nether_brick_wall": "wall o' scarlet bricks o' nether",
  "block.minecraft.sandstone_wall": "wall o' stone o' sands",
  "block.minecraft.end_stone_brick_wall": "wall o' foreign stone brick",
  "block.minecraft.diorite_wall": "wall o' white pebbles",
  "block.minecraft.blackstone_wall": "wall o' rock o' black",
  "block.minecraft.polished_blackstone_wall": "wall o' good lookin' black rock",
  "block.minecraft.polished_blackstone_brick_wall": "good lookin' wall o' bricks o' rock o' black",
  "block.minecraft.stone_button": "knob o' rock",
  "block.minecraft.oak_button": "knob o' oak",
  "block.minecraft.spruce_button": "knob o' spruce",
  "block.minecraft.birch_button": "knob o' birch",
  "block.minecraft.jungle_button": "knob o' jungle",
  "block.minecraft.acacia_button": "knob o' acacia",
  "block.minecraft.dark_oak_button": "knob o' dusky oak",
  "block.minecraft.crimson_button": "knob o' ichor",
  "block.minecraft.warped_button": "odd button o' hyphae",
  "block.minecraft.polished_blackstone_button": "knob o' good lookin' black rock",
  "block.minecraft.anvil": "slab o' fixin'",
  "block.minecraft.chipped_anvil": "chipped slab o' fixin'",
  "block.minecraft.damaged_anvil": "cracked slab o' fixin'",
  "block.minecraft.trapped_chest": "trapped coffer",
  "block.minecraft.light_weighted_pressure_plate": "booby trap o' light heft",
  "block.minecraft.heavy_weighted_pressure_plate": "booby trap o' heavy heft",
  "block.minecraft.daylight_detector": "sunrise finder",
  "block.minecraft.redstone_block": "chunk o' redstone",
  "block.minecraft.nether_quartz_ore": "orrre o' white rock",
  "block.minecraft.hopper": "suckin' device",
  "block.minecraft.chiseled_quartz_block": "carv'd chunk o' white rock",
  "block.minecraft.quartz_block": "chunk o' white rock",
  "block.minecraft.quartz_bricks": "bricks o' white rock",
  "block.minecraft.quartz_pillar": "post o' white rock",
  "block.minecraft.quartz_stairs": "stairs o' white rock",
  "block.minecraft.activator_rail": "fuse track",
  "block.minecraft.dropper": "broken cannon",
  "block.minecraft.white_terracotta": "white ancient clay",
  "block.minecraft.orange_terracotta": "orange ancient clay",
  "block.minecraft.magenta_terracotta": "magenta ancient clay",
  "block.minecraft.light_blue_terracotta": "light blue ancient clay",
  "block.minecraft.yellow_terracotta": "yellow ancient clay",
  "block.minecraft.lime_terracotta": "lime ancient clay",
  "block.minecraft.pink_terracotta": "pink ancient clay",
  "block.minecraft.gray_terracotta": "gray ancient clay",
  "block.minecraft.light_gray_terracotta": "light gray ancient clay",
  "block.minecraft.cyan_terracotta": "cyan ancient clay",
  "block.minecraft.purple_terracotta": "purple ancient clay",
  "block.minecraft.blue_terracotta": "blue ancient clay",
  "block.minecraft.brown_terracotta": "brown ancient clay",
  "block.minecraft.green_terracotta": "green ancient clay",
  "block.minecraft.red_terracotta": "scarlet ancient clay",
  "block.minecraft.black_terracotta": "black ancient clay",
  "block.minecraft.barrier": "invisible wall",
  "block.minecraft.iron_trapdoor": "hatch o' steel",
  "block.minecraft.hay_block": "bale o' hops",
  "block.minecraft.white_carpet": "white rug",
  "block.minecraft.orange_carpet": "orange rug",
  "block.minecraft.magenta_carpet": "light purple rug",
  "block.minecraft.light_blue_carpet": "light blue rug",
  "block.minecraft.yellow_carpet": "yellow rug",
  "block.minecraft.lime_carpet": "light green rug",
  "block.minecraft.pink_carpet": "pink rug",
  "block.minecraft.gray_carpet": "gray rug",
  "block.minecraft.light_gray_carpet": "light gray rug",
  "block.minecraft.cyan_carpet": "ocean blue rug",
  "block.minecraft.purple_carpet": "purple rug",
  "block.minecraft.blue_carpet": "blue rug",
  "block.minecraft.brown_carpet": "brown rug",
  "block.minecraft.green_carpet": "green rug",
  "block.minecraft.red_carpet": "scarlet rug",
  "block.minecraft.black_carpet": "black rug",
  "block.minecraft.terracotta": "ancient clay",
  "block.minecraft.coal_block": "chunk o' fuel",
  "block.minecraft.packed_ice": "tough frost",
  "block.minecraft.acacia_stairs": "stairs o' acacia",
  "block.minecraft.dark_oak_stairs": "stairs o' dusky oak",
  "block.minecraft.slime_block": "block o' slime",
  "block.minecraft.grass_path": "trodden path",
  "block.minecraft.sunflower": "sunflower",
  "block.minecraft.lilac": "ye lilac bouquet f' t' gals",
  "block.minecraft.rose_bush": "bush o' roses",
  "block.minecraft.peony": "yer massive pink flower",
  "block.minecraft.tall_grass": "mighty grass",
  "block.minecraft.large_fern": "whopper tree",
  "block.minecraft.white_stained_glass": "white crystal",
  "block.minecraft.orange_stained_glass": "orange crystal",
  "block.minecraft.magenta_stained_glass": "light purple crystal",
  "block.minecraft.light_blue_stained_glass": "light blue crystal",
  "block.minecraft.yellow_stained_glass": "yellow crystal",
  "block.minecraft.lime_stained_glass": "light green crystal",
  "block.minecraft.pink_stained_glass": "pink crystal",
  "block.minecraft.gray_stained_glass": "gray crystal",
  "block.minecraft.light_gray_stained_glass": "light gray crystal",
  "block.minecraft.cyan_stained_glass": "ocean blue crystal",
  "block.minecraft.purple_stained_glass": "purple crystal",
  "block.minecraft.blue_stained_glass": "blue crystal",
  "block.minecraft.brown_stained_glass": "brown crystal",
  "block.minecraft.green_stained_glass": "green crystal",
  "block.minecraft.red_stained_glass": "scarlet crystal",
  "block.minecraft.black_stained_glass": "black crystal",
  "block.minecraft.white_stained_glass_pane": "white crystal",
  "block.minecraft.orange_stained_glass_pane": "orange porthole",
  "block.minecraft.magenta_stained_glass_pane": "light purple porthole",
  "block.minecraft.light_blue_stained_glass_pane": "light blue porthole",
  "block.minecraft.yellow_stained_glass_pane": "yellow porthole",
  "block.minecraft.lime_stained_glass_pane": "light green porthole",
  "block.minecraft.pink_stained_glass_pane": "pink porthole",
  "block.minecraft.gray_stained_glass_pane": "gray porthole",
  "block.minecraft.light_gray_stained_glass_pane": "light gray porthole",
  "block.minecraft.cyan_stained_glass_pane": "ocean blue porthole",
  "block.minecraft.purple_stained_glass_pane": "purple porthole",
  "block.minecraft.blue_stained_glass_pane": "blue porthole",
  "block.minecraft.brown_stained_glass_pane": "brown porthole",
  "block.minecraft.green_stained_glass_pane": "green porthole",
  "block.minecraft.red_stained_glass_pane": "scarlet porthole",
  "block.minecraft.black_stained_glass_pane": "black porthole",
  "block.minecraft.prismarine": "prismarine",
  "block.minecraft.prismarine_bricks": "bricks o' prismarine",
  "block.minecraft.dark_prismarine": "dusky prismarine",
  "block.minecraft.prismarine_stairs": "stairs o' prismarine",
  "block.minecraft.prismarine_brick_stairs": "stairs o' prismarine bricks",
  "block.minecraft.dark_prismarine_stairs": "stairs o' dusky prismarine",
  "block.minecraft.sea_lantern": "light buoy",
  "block.minecraft.red_sandstone": "scarlet stone o' sands",
  "block.minecraft.chiseled_red_sandstone": "carv'd scarlet stone o' sands",
  "block.minecraft.cut_red_sandstone": "cut scarlet stone o' sands",
  "block.minecraft.red_sandstone_stairs": "stairs o' scarlet stone o' sands",
  "block.minecraft.repeating_command_block": "quick order block",
  "block.minecraft.chain_command_block": "chained order block",
  "block.minecraft.magma_block": "davy jones's heat",
  "block.minecraft.nether_wart_block": "hell's wart",
  "block.minecraft.warped_wart_block": "blue 'shroom o' doom",
  "block.minecraft.red_nether_bricks": "scarlet bricks o' nether",
  "block.minecraft.bone_block": "block o' bone",
  "block.minecraft.structure_void": "nothin' here, lads",
  "block.minecraft.observer": "snooper",
  "block.minecraft.shulker_box": "shulker box",
  "block.minecraft.white_shulker_box": "white shulker box",
  "block.minecraft.orange_shulker_box": "orange shulker box",
  "block.minecraft.magenta_shulker_box": "light purple shulker box",
  "block.minecraft.light_blue_shulker_box": "light blue shulker box",
  "block.minecraft.yellow_shulker_box": "yellow shulker box",
  "block.minecraft.lime_shulker_box": "light green shulker box",
  "block.minecraft.pink_shulker_box": "pink shulker box",
  "block.minecraft.gray_shulker_box": "gray shulker box",
  "block.minecraft.light_gray_shulker_box": "light gray shulker box",
  "block.minecraft.cyan_shulker_box": "ocean blue shulker box",
  "block.minecraft.purple_shulker_box": "purple shulker box",
  "block.minecraft.blue_shulker_box": "blue shulker box",
  "block.minecraft.brown_shulker_box": "brown shulker box",
  "block.minecraft.green_shulker_box": "green shulker box",
  "block.minecraft.red_shulker_box": "scarlet shulker box",
  "block.minecraft.black_shulker_box": "black shulker box",
  "block.minecraft.white_glazed_terracotta": "white pricey mosaic",
  "block.minecraft.orange_glazed_terracotta": "orange pricey mosaic",
  "block.minecraft.magenta_glazed_terracotta": "light purple pricey mosaic",
  "block.minecraft.light_blue_glazed_terracotta": "light blue pricey mosaic",
  "block.minecraft.yellow_glazed_terracotta": "yellow pricey mosaic",
  "block.minecraft.lime_glazed_terracotta": "light green pricey mosaic",
  "block.minecraft.pink_glazed_terracotta": "pink pricey mosaic",
  "block.minecraft.gray_glazed_terracotta": "gray pricey mosaic",
  "block.minecraft.light_gray_glazed_terracotta": "light gray pricey mosaic",
  "block.minecraft.cyan_glazed_terracotta": "ocean blue pricey mosaic",
  "block.minecraft.purple_glazed_terracotta": "purple pricey mosaic",
  "block.minecraft.blue_glazed_terracotta": "blue pricey mosaic",
  "block.minecraft.brown_glazed_terracotta": "brown pricey mosaic",
  "block.minecraft.green_glazed_terracotta": "green pricey mosaic",
  "block.minecraft.red_glazed_terracotta": "scarlet pricey mosaic",
  "block.minecraft.black_glazed_terracotta": "black pricey mosaic",
  "block.minecraft.white_concrete": "white cement",
  "block.minecraft.orange_concrete": "orange cement",
  "block.minecraft.magenta_concrete": "magenta cement",
  "block.minecraft.light_blue_concrete": "light blue cement",
  "block.minecraft.yellow_concrete": "yellow cement",
  "block.minecraft.lime_concrete": "lime cement",
  "block.minecraft.pink_concrete": "pink cement",
  "block.minecraft.gray_concrete": "gray cement",
  "block.minecraft.light_gray_concrete": "light gray cement",
  "block.minecraft.cyan_concrete": "cyan cement",
  "block.minecraft.purple_concrete": "purple cement",
  "block.minecraft.blue_concrete": "blue cement",
  "block.minecraft.brown_concrete": "brown cement",
  "block.minecraft.green_concrete": "green cement",
  "block.minecraft.red_concrete": "scarlet cement",
  "block.minecraft.black_concrete": "black cement",
  "block.minecraft.white_concrete_powder": "white cement dusts",
  "block.minecraft.orange_concrete_powder": "orange cement dusts",
  "block.minecraft.magenta_concrete_powder": "magenta cement dusts",
  "block.minecraft.light_blue_concrete_powder": "light blue cement dusts",
  "block.minecraft.yellow_concrete_powder": "yellow cement dusts",
  "block.minecraft.lime_concrete_powder": "lime cement dusts",
  "block.minecraft.pink_concrete_powder": "pink cement dusts",
  "block.minecraft.gray_concrete_powder": "gray cement dusts",
  "block.minecraft.light_gray_concrete_powder": "light gray cement dusts",
  "block.minecraft.cyan_concrete_powder": "cyan cement dusts",
  "block.minecraft.purple_concrete_powder": "purple cement dusts",
  "block.minecraft.blue_concrete_powder": "blue cement dusts",
  "block.minecraft.brown_concrete_powder": "brown cement dusts",
  "block.minecraft.green_concrete_powder": "green cement dusts",
  "block.minecraft.red_concrete_powder": "scarlet cement dusts",
  "block.minecraft.black_concrete_powder": "black cement dusts",
  "block.minecraft.turtle_egg": "turtle cackle fruit",
  "block.minecraft.dead_tube_coral_block": "chunk o' dead cylind'r coral",
  "block.minecraft.dead_brain_coral_block": "chunk o' dead walnut coral",
  "block.minecraft.dead_bubble_coral_block": "chunk o' dead cyst coral",
  "block.minecraft.dead_fire_coral_block": "chunk o' dead burnin' coral",
  "block.minecraft.dead_horn_coral_block": "chunk o' dead horn coral",
  "block.minecraft.tube_coral_block": "chunk o' cylind'r coral",
  "block.minecraft.brain_coral_block": "chunk o' walnut coral",
  "block.minecraft.bubble_coral_block": "chunk o' cyst coral",
  "block.minecraft.fire_coral_block": "chunk o' burnin coral",
  "block.minecraft.horn_coral_block": "chunk o' horn coral",
  "block.minecraft.tube_coral": "cylind'r coral",
  "block.minecraft.brain_coral": "walnut coral",
  "block.minecraft.bubble_coral": "cyst coral",
  "block.minecraft.fire_coral": "burnin coral",
  "block.minecraft.horn_coral": "horn coral",
  "block.minecraft.dead_brain_coral": "dead walnut coral",
  "block.minecraft.dead_bubble_coral": "dead cyst coral",
  "block.minecraft.dead_fire_coral": "dead burnin' coral",
  "block.minecraft.dead_horn_coral": "dead horn coral",
  "block.minecraft.dead_tube_coral": "dead cylind'r o' coral",
  "block.minecraft.tube_coral_fan": "cylind'r coral waf'r",
  "block.minecraft.brain_coral_fan": "brain coral waf'r",
  "block.minecraft.bubble_coral_fan": "cyst coral waf'r",
  "block.minecraft.fire_coral_fan": "burnin coral waf'r",
  "block.minecraft.horn_coral_fan": "horn coral waf'r",
  "block.minecraft.dead_tube_coral_fan": "dead cylind'r coral waf'r",
  "block.minecraft.dead_brain_coral_fan": "dead walnut coral waf'r",
  "block.minecraft.dead_bubble_coral_fan": "dead cyst coral waf'r",
  "block.minecraft.dead_fire_coral_fan": "dead burnin' coral waf'r",
  "block.minecraft.dead_horn_coral_fan": "dead horn coral waf'r",
  "block.minecraft.blue_ice": "blue frost",
  "block.minecraft.conduit": "source o' th' seas",
  "block.minecraft.polished_granite_stairs": "stairs o' good lookin' brown pebbles",
  "block.minecraft.smooth_red_sandstone_stairs": "stairs o' smooth scarlet stone o' sands",
  "block.minecraft.mossy_stone_brick_stairs": "stairs o' slimy bricks o' stone",
  "block.minecraft.polished_diorite_stairs": "stairs o' good lookin' white pebbles",
  "block.minecraft.mossy_cobblestone_stairs": "stairs o' slimy pebbles",
  "block.minecraft.end_stone_brick_stairs": "stairs o' foreign stone brick",
  "block.minecraft.stone_stairs": "stairs o' rock",
  "block.minecraft.smooth_sandstone_stairs": "stairs o' smooth stone o' sands",
  "block.minecraft.smooth_quartz_stairs": "stairs o' smooth white rock",
  "block.minecraft.granite_stairs": "stairs o' brown pebbles",
  "block.minecraft.andesite_stairs": "stairs o' gray pebbles",
  "block.minecraft.red_nether_brick_stairs": "stairs o' scarlet bricks o' nether",
  "block.minecraft.polished_andesite_stairs": "stairs o' good lookin' gray pebbles",
  "block.minecraft.diorite_stairs": "stairs o' white pebbles",
  "block.minecraft.polished_granite_slab": "slab o' good lookin' brown pebbles",
  "block.minecraft.smooth_red_sandstone_slab": "slab o' smooth scarlet stone o' sands",
  "block.minecraft.mossy_stone_brick_slab": "slab o' slimy bricks o' stone",
  "block.minecraft.polished_diorite_slab": "slab o' good lookin' white pebbles",
  "block.minecraft.mossy_cobblestone_slab": "slab o' slimy pebbles",
  "block.minecraft.end_stone_brick_slab": "slab o' foreign stone brick",
  "block.minecraft.smooth_sandstone_slab": "slab o' smooth stone o' sands",
  "block.minecraft.smooth_quartz_slab": "slab o' smooth white rock",
  "block.minecraft.granite_slab": "slab o' brown pebbles",
  "block.minecraft.andesite_slab": "slab o' gray pebbles",
  "block.minecraft.red_nether_brick_slab": "slab o' scarlet bricks o' nether",
  "block.minecraft.polished_andesite_slab": "slab o' good lookin' gray pebbles",
  "block.minecraft.diorite_slab": "slab o' white pebbles",
  "block.minecraft.scaffolding": "shipbuildin' frame",
  "block.minecraft.iron_door": "door o' steel",
  "block.minecraft.oak_door": "door o' oak",
  "block.minecraft.spruce_door": "door o' spruce",
  "block.minecraft.birch_door": "door o' birch",
  "block.minecraft.jungle_door": "door o' jungle",
  "block.minecraft.acacia_door": "door o' acacia",
  "block.minecraft.dark_oak_door": "door o' dusky oak",
  "block.minecraft.crimson_door": "door o' ichor",
  "block.minecraft.warped_door": "unnatural gateway o' hyphae",
  "block.minecraft.repeater": "redstone repeatarrr",
  "block.minecraft.comparator": "redstone compaaratorrr",
  "block.minecraft.structure_block": "ship sav'r",
  "block.minecraft.jigsaw": "pieces o' eight block",
  "item.minecraft.turtle_helmet": "shell o' turtle□□if on yer noggin':□+2 protectin'",
  "item.minecraft.scute": "piece o' turtleshell",
  "item.minecraft.iron_shovel": "spade o' steel□□if in yer main hook:□+3.5 attack damage□-3 fastness o' attack",
  "item.minecraft.iron_pickaxe": "pickaxe o' steel□□if in yer main hook:□+3 attack damage□-2.8 fastness o' attack",
  "item.minecraft.iron_axe": "hatchet o' steel□□if in yer main hook:□+8 attack damage□-3.1 fastness o' attack",
  "item.minecraft.flint_and_steel": "ship's bane",
  "item.minecraft.apple": "scurvy's cure",
  "item.minecraft.bow": "flintlock",
  "item.minecraft.arrow": "bolt",
  "item.minecraft.coal": "fuel",
  "item.minecraft.charcoal": "burnt timber",
  "item.minecraft.diamond": "diamond",
  "item.minecraft.iron_ingot": "bullion o' steel",
  "item.minecraft.gold_ingot": "bullion o' gold",
  "item.minecraft.netherite_ingot": "bullion o' blackbeard's alloy",
  "item.minecraft.netherite_scrap": "blackbeard's scrap",
  "item.minecraft.iron_sword": "cutlass o' steel□□if in yer main hook:□+5 attack damage□-2.4 fastness o' attack",
  "item.minecraft.wooden_sword": "cutlass o' timber□□if in yer main hook:□+3 attack damage□-2.4 fastness o' attack",
  "item.minecraft.wooden_shovel": "spade o' timber□□if in yer main hook:□+1.5 attack damage□-3 fastness o' attack",
  "item.minecraft.wooden_pickaxe": "pickaxe o' timber□□if in yer main hook:□+1 attack damage□-2.8 fastness o' attack",
  "item.minecraft.wooden_axe": "hatchet o' timber□□if in yer main hook:□+6 attack damage□-3.2 fastness o' attack",
  "item.minecraft.stone_sword": "cutlass o' rock□□if in yer main hook:□+4 attack damage□-2.4 fastness o' attack",
  "item.minecraft.stone_shovel": "spade o' rock□□if in yer main hook:□+2.5 attack damage□-3 fastness o' attack",
  "item.minecraft.stone_pickaxe": "pickaxe o' rock□□if in yer main hook:□+2 attack damage□-2.8 fastness o' attack",
  "item.minecraft.stone_axe": "hatchet o' rock□□if in yer main hook:□+8 attack damage□-3.2 fastness o' attack",
  "item.minecraft.diamond_sword": "cutlass o' diamond□□if in yer main hook:□+6 attack damage□-2.4 fastness o' attack",
  "item.minecraft.diamond_shovel": "spade o' diamond□□if in yer main hook:□+4.5 attack damage□-3 fastness o' attack",
  "item.minecraft.diamond_pickaxe": "pickaxe o' diamond□□if in yer main hook:□+4 attack damage□-2.8 fastness o' attack",
  "item.minecraft.diamond_axe": "hatchet o' diamond□□if in yer main hook:□+8 attack damage□-3 fastness o' attack",
  "item.minecraft.stick": "piece o' timber",
  "item.minecraft.bowl": "nipperkin",
  "item.minecraft.mushroom_stew": "shroom goulash",
  "item.minecraft.golden_sword": "cutlass o' gold□□if in yer main hook:□+3 attack damage□-2.4 fastness o' attack",
  "item.minecraft.golden_shovel": "spade o' gold□□if in yer main hook:□+1.5 attack damage□-3 fastness o' attack",
  "item.minecraft.golden_pickaxe": "pickaxe o' gold□□if in yer main hook:□+1 attack damage□-2.8 fastness o' attack",
  "item.minecraft.golden_axe": "hatchet o' gold□□if in yer main hook:□+6 attack damage□-3 fastness o' attack",
  "item.minecraft.netherite_sword": "blackbeard's claymore□□if in yer main hook:□+7 attack damage□-2.4 fastness o' attack",
  "item.minecraft.netherite_shovel": "blackbeard's spade□□if in yer main hook:□+5.5 attack damage□-3 fastness o' attack",
  "item.minecraft.netherite_pickaxe": "blackbeard's pickaxe□□if in yer main hook:□+5 attack damage□-2.8 fastness o' attack",
  "item.minecraft.netherite_axe": "blackbeard's battleaxe□□if in yer main hook:□+9 attack damage□-3 fastness o' attack",
  "item.minecraft.string": "cheap rope",
  "item.minecraft.feather": "feather",
  "item.minecraft.gunpowder": "black powder",
  "item.minecraft.wooden_hoe": "farmin' stick o' timber□□if in yer main hook:□-3 fastness o' attack",
  "item.minecraft.stone_hoe": "farmin' stick o' rock□□if in yer main hook:□-2 fastness o' attack",
  "item.minecraft.iron_hoe": "farmin' stick o' steel□□if in yer main hook:□-1 fastness o' attack",
  "item.minecraft.diamond_hoe": "farmin' stick o' diamond□□if in yer main hook:",
  "item.minecraft.golden_hoe": "farmin' stick o' gold□□if in yer main hook:□-3 fastness o' attack",
  "item.minecraft.netherite_hoe": "blackbeard's scythe□□if in yer main hook:",
  "item.minecraft.wheat_seeds": "seeds o' hops",
  "item.minecraft.wheat": "hops",
  "item.minecraft.bread": "hard tack",
  "item.minecraft.leather_helmet": "bandana o' leather□□if on yer noggin':□+1 protectin'",
  "item.minecraft.leather_chestplate": "jacket o' leather□□if on yer torso:□+3 protectin'",
  "item.minecraft.leather_leggings": "breeches o' leather□□if on yer peg-legs:□+2 protectin'",
  "item.minecraft.leather_boots": "peg-leg o' leather□□if on yer footsies:□+1 protectin'",
  "item.minecraft.chainmail_helmet": "helmet o' metal links□□if on yer noggin':□+2 protectin'",
  "item.minecraft.chainmail_chestplate": "chestplate o' metal links□□if on yer torso:□+5 protectin'",
  "item.minecraft.chainmail_leggings": "greaves o' metal links□□if on yer peg-legs:□+4 protectin'",
  "item.minecraft.chainmail_boots": "peg-leg o' metal links□□if on yer footsies:□+1 protectin'",
  "item.minecraft.iron_helmet": "helmet o' steel□□if on yer noggin':□+2 protectin'",
  "item.minecraft.iron_chestplate": "chestplate o' steel□□if on yer torso:□+6 protectin'",
  "item.minecraft.iron_leggings": "greaves o' steel□□if on yer peg-legs:□+5 protectin'",
  "item.minecraft.iron_boots": "peg-leg o' steel□□if on yer footsies:□+2 protectin'",
  "item.minecraft.diamond_helmet": "helmet o' diamond□□if on yer noggin':□+3 protectin'□+2 protectin' strongness",
  "item.minecraft.diamond_chestplate": "chestplate o' diamond□□if on yer torso:□+8 protectin'□+2 protectin' strongness",
  "item.minecraft.diamond_leggings": "greaves o' diamond□□if on yer peg-legs:□+6 protectin'□+2 protectin' strongness",
  "item.minecraft.diamond_boots": "peg-leg o' diamond□□if on yer footsies:□+3 protectin'□+2 protectin' strongness",
  "item.minecraft.golden_helmet": "helmet o' gold□□if on yer noggin':□+2 protectin'",
  "item.minecraft.golden_chestplate": "chestplate o' gold□□if on yer torso:□+5 protectin'",
  "item.minecraft.golden_leggings": "greaves o' gold□□if on yer peg-legs:□+3 protectin'",
  "item.minecraft.golden_boots": "peg-leg o' gold□□if on yer footsies:□+1 protectin'",
  "item.minecraft.netherite_helmet": "blackbeard's tricorn hat□□if on yer noggin':□+3 protectin'□+3 protectin' strongness□+1 blowback resistance",
  "item.minecraft.netherite_chestplate": "blackbeard's doublet□□if on yer torso:□+8 protectin'□+3 protectin' strongness□+1 blowback resistance",
  "item.minecraft.netherite_leggings": "blackbeard's breeches□□if on yer peg-legs:□+6 protectin'□+3 protectin' strongness□+1 blowback resistance",
  "item.minecraft.netherite_boots": "blackbeard's waders□□if on yer footsies:□+3 protectin'□+3 protectin' strongness□+1 blowback resistance",
  "item.minecraft.flint": "pointy rock",
  "item.minecraft.porkchop": "raw pigmeat",
  "item.minecraft.cooked_porkchop": "cooked swine",
  "item.minecraft.painting": "portrait",
  "item.minecraft.golden_apple": "eden's apple",
  "item.minecraft.enchanted_golden_apple": "witchcraft'd golden apple",
  "block.minecraft.oak_sign": "seal o' oak",
  "block.minecraft.spruce_sign": "seal o' spruce",
  "block.minecraft.birch_sign": "seal o' birch",
  "block.minecraft.jungle_sign": "seal o' jungle",
  "block.minecraft.acacia_sign": "seal o' acacia",
  "block.minecraft.dark_oak_sign": "seal o' dusky oak",
  "block.minecraft.crimson_sign": "seal o' ichor",
  "block.minecraft.warped_sign": "message o' twistin'",
  "item.minecraft.bucket": "pail",
  "item.minecraft.water_bucket": "pail o' bilge",
  "item.minecraft.lava_bucket": "pail o' molten rock",
  "item.minecraft.minecart": "landlubbers' boat",
  "item.minecraft.saddle": "saddle",
  "item.minecraft.redstone": "redstone powder",
  "item.minecraft.snowball": "ball o' snow",
  "item.minecraft.oak_boat": "oak'n vessel",
  "item.minecraft.leather": "leather",
  "item.minecraft.milk_bucket": "bovine's juice",
  "item.minecraft.pufferfish_bucket": "pail o' blowfish",
  "item.minecraft.salmon_bucket": "pail o' salmon",
  "item.minecraft.cod_bucket": "pail o' codfish",
  "item.minecraft.tropical_fish_bucket": "pail o' colorful fish",
  "item.minecraft.brick": "brick o' clay",
  "item.minecraft.clay_ball": "ball o' solid mud",
  "block.minecraft.dried_kelp_block": "chunk o' dry sea lettuce",
  "item.minecraft.paper": "parchment",
  "item.minecraft.book": "logbook",
  "item.minecraft.slime_ball": "ball o' slime",
  "item.minecraft.chest_minecart": "coffer in a landlubbers' boat",
  "item.minecraft.furnace_minecart": "oven in a landlubbers' boat",
  "item.minecraft.egg": "cackle fruit",
  "item.minecraft.compass": "sextant",
  "item.minecraft.fishing_rod": "fishin' rod",
  "item.minecraft.clock": "hourglass",
  "item.minecraft.glowstone_dust": "glowstone powder",
  "item.minecraft.cod": "raw codfish",
  "item.minecraft.salmon": "raw salmon",
  "item.minecraft.tropical_fish": "colorful fish",
  "item.minecraft.pufferfish": "blowfish",
  "item.minecraft.cooked_cod": "smoked codfish",
  "item.minecraft.cooked_salmon": "smoked salmon",
  "item.minecraft.ink_sac": "kraken's paint",
  "item.minecraft.red_dye": "dye o' scarlet",
  "item.minecraft.green_dye": "dye o' green",
  "item.minecraft.cocoa_beans": "beans o' cacao",
  "item.minecraft.lapis_lazuli": "lāzhward",
  "item.minecraft.purple_dye": "dye o' purple",
  "item.minecraft.cyan_dye": "dye o' cyan",
  "item.minecraft.light_gray_dye": "dye o' light gray",
  "item.minecraft.gray_dye": "dye o' gray",
  "item.minecraft.pink_dye": "dye o' pink",
  "item.minecraft.lime_dye": "dye o' lime",
  "item.minecraft.yellow_dye": "dye o' yellow",
  "item.minecraft.light_blue_dye": "dye o' light blue",
  "item.minecraft.magenta_dye": "dye o' magenta",
  "item.minecraft.orange_dye": "dye o' orange",
  "item.minecraft.bone_meal": "mashed bones",
  "item.minecraft.blue_dye": "dye o' blue",
  "item.minecraft.brown_dye": "dye o' brown",
  "item.minecraft.black_dye": "dye o' black",
  "item.minecraft.white_dye": "dye o' white",
  "item.minecraft.bone": "bone",
  "item.minecraft.sugar": "sugarrr",
  "block.minecraft.cake": "duff",
  "block.minecraft.white_bed": "white bunk",
  "block.minecraft.orange_bed": "orange bunk",
  "block.minecraft.magenta_bed": "light purple bunk",
  "block.minecraft.light_blue_bed": "light blue bunk",
  "block.minecraft.yellow_bed": "yellow bunk",
  "block.minecraft.lime_bed": "vomit bunk",
  "block.minecraft.pink_bed": "pink bunk",
  "block.minecraft.gray_bed": "gray bunk",
  "block.minecraft.light_gray_bed": "light gray bunk",
  "block.minecraft.cyan_bed": "ocean blue bunk",
  "block.minecraft.purple_bed": "purple bunk",
  "block.minecraft.blue_bed": "blue bunk",
  "block.minecraft.brown_bed": "brown bunk",
  "block.minecraft.green_bed": "green bunk",
  "block.minecraft.red_bed": "scarlet bunk",
  "block.minecraft.black_bed": "black bunk",
  "item.minecraft.cookie": "biscuit",
  "item.minecraft.filled_map": "treasure map□#0",
  "item.minecraft.shears": "cutters",
  "item.minecraft.melon_slice": "slic'd melon",
  "item.minecraft.dried_kelp": "dry sea lettuce",
  "item.minecraft.pumpkin_seeds": "seeds o' gourd squash",
  "item.minecraft.melon_seeds": "seeds o' tha melons'",
  "item.minecraft.beef": "raw beef",
  "item.minecraft.cooked_beef": "steak",
  "item.minecraft.chicken": "raw fowl",
  "item.minecraft.cooked_chicken": "cooked fowl",
  "item.minecraft.rotten_flesh": "putrid rations",
  "item.minecraft.ender_pearl": "tall man's treasure",
  "item.minecraft.blaze_rod": "burnin' stick",
  "item.minecraft.ghast_tear": "tear o' ghast",
  "item.minecraft.gold_nugget": "doubloon o' gold",
  "item.minecraft.nether_wart": "verruca o' nether",
  "item.minecraft.potion": "uncraftable grog□useless",
  "item.minecraft.glass_bottle": "empty bottle o' rum",
  "item.minecraft.spider_eye": "spider eyeball",
  "item.minecraft.fermented_spider_eye": "rotten eye o' eightlegs",
  "item.minecraft.blaze_powder": "blisterin' blaze powder",
  "item.minecraft.magma_cream": "flamin' cream",
  "block.minecraft.brewing_stand": "still",
  "block.minecraft.cauldron": "pot",
  "item.minecraft.ender_eye": "eye o' ender",
  "item.minecraft.glistering_melon_slice": "shining melon slice",
  "item.minecraft.bat_spawn_egg": "flying mouse cackle fruit",
  "item.minecraft.bee_spawn_egg": "bee cackle fruit",
  "item.minecraft.blaze_spawn_egg": "blisterin' blaze cackle fruit",
  "item.minecraft.cat_spawn_egg": "cat cackle fruit",
  "item.minecraft.cave_spider_spawn_egg": "spider o' cave cackle fruit",
  "item.minecraft.chicken_spawn_egg": "chick'n cackle fruit",
  "item.minecraft.cod_spawn_egg": "cod cackle fruit",
  "item.minecraft.cow_spawn_egg": "bovine cackle fruit",
  "item.minecraft.creeper_spawn_egg": "creeper cackle fruit",
  "item.minecraft.dolphin_spawn_egg": "treasure hound cackle fruit",
  "item.minecraft.donkey_spawn_egg": "furry cargo cackle fruit",
  "item.minecraft.drowned_spawn_egg": "sunken sailor cackle fruit",
  "item.minecraft.elder_guardian_spawn_egg": "great sea lurker cackle fruit",
  "item.minecraft.enderman_spawn_egg": "enderman cackle fruit",
  "item.minecraft.endermite_spawn_egg": "endermite cackle fruit",
  "item.minecraft.evoker_spawn_egg": "evil wizard cackle fruit",
  "item.minecraft.fox_spawn_egg": "fox cackle fruit",
  "item.minecraft.ghast_spawn_egg": "ghast cackle fruit",
  "item.minecraft.guardian_spawn_egg": "sea lurker cackle fruit",
  "item.minecraft.hoglin_spawn_egg": "devil's manatee cackle fruit",
  "item.minecraft.horse_spawn_egg": "brumby cackle fruit",
  "item.minecraft.husk_spawn_egg": "heated sailor cackle fruit",
  "item.minecraft.llama_spawn_egg": "spitting sheep cackle fruit",
  "item.minecraft.magma_cube_spawn_egg": "cube o' magma cackle fruit",
  "item.minecraft.mooshroom_spawn_egg": "mooshroom cackle fruit",
  "item.minecraft.mule_spawn_egg": "mule cackle fruit",
  "item.minecraft.ocelot_spawn_egg": "cat o' jungles cackle fruit",
  "item.minecraft.panda_spawn_egg": "landlubbin' orca cackle fruit",
  "item.minecraft.parrot_spawn_egg": "yer' best matey cackle fruit",
  "item.minecraft.phantom_spawn_egg": "flying devil cackle fruit",
  "item.minecraft.pig_spawn_egg": "swine cackle fruit",
  "item.minecraft.piglin_spawn_egg": "devil's swine cackle fruit",
  "item.minecraft.pillager_spawn_egg": "raider cackle fruit",
  "item.minecraft.polar_bear_spawn_egg": "polar bear cackle fruit",
  "item.minecraft.pufferfish_spawn_egg": "blowfish cackle fruit",
  "item.minecraft.rabbit_spawn_egg": "rabbit cackle fruit",
  "item.minecraft.ravager_spawn_egg": "arrvager cackle fruit",
  "item.minecraft.salmon_spawn_egg": "salmon cackle fruit",
  "item.minecraft.sheep_spawn_egg": "sheep cackle fruit",
  "item.minecraft.shulker_spawn_egg": "shulker cackle fruit",
  "item.minecraft.silverfish_spawn_egg": "bilge rat cackle fruit",
  "item.minecraft.skeleton_spawn_egg": "bag o' bones cackle fruit",
  "item.minecraft.skeleton_horse_spawn_egg": "bag o' bones' brumby cackle fruit",
  "item.minecraft.slime_spawn_egg": "cube o' slime cackle fruit",
  "item.minecraft.spider_spawn_egg": "spider cackle fruit",
  "item.minecraft.squid_spawn_egg": "kraken cackle fruit",
  "item.minecraft.stray_spawn_egg": "wandering bag o' bones cackle fruit",
  "item.minecraft.strider_spawn_egg": "jellyfish o' lava cackle fruit",
  "item.minecraft.trader_llama_spawn_egg": "nomad's spitting sheep cackle fruit",
  "item.minecraft.tropical_fish_spawn_egg": "fish o’ tropical cackle fruit",
  "item.minecraft.turtle_spawn_egg": "turtle cackle fruit",
  "item.minecraft.vex_spawn_egg": "nagger cackle fruit",
  "item.minecraft.villager_spawn_egg": "landlubber cackle fruit",
  "item.minecraft.vindicator_spawn_egg": "servant cackle fruit",
  "item.minecraft.wandering_trader_spawn_egg": "movin' merchant cackle fruit",
  "item.minecraft.witch_spawn_egg": "wizard cackle fruit",
  "item.minecraft.wither_skeleton_spawn_egg": "corrupted bag o' bones cackle fruit",
  "item.minecraft.wolf_spawn_egg": "hound cackle fruit",
  "item.minecraft.zoglin_spawn_egg": "corpse o' devil's manatee cackle fruit",
  "item.minecraft.zombie_spawn_egg": "undead sailor cackle fruit",
  "item.minecraft.zombie_horse_spawn_egg": "undead brumby cackle fruit",
  "item.minecraft.zombie_villager_spawn_egg": "undead landlubber cackle fruit",
  "item.minecraft.zombified_piglin_spawn_egg": "corpse o' devil's swine cackle fruit",
  "item.minecraft.experience_bottle": "rum o' wisdom",
  "item.minecraft.fire_charge": "cannonball",
  "item.minecraft.writable_book": "captain's log",
  "item.minecraft.written_book": "full logbook",
  "item.minecraft.emerald": "emerald",
  "item.minecraft.item_frame": "booty holder",
  "block.minecraft.flower_pot": "dirt vase",
  "item.minecraft.carrot": "orange veggy",
  "item.minecraft.potato": "tater",
  "item.minecraft.baked_potato": "baked tater",
  "item.minecraft.poisonous_potato": "toxic tater",
  "item.minecraft.map": "em'ty treasure map",
  "item.minecraft.golden_carrot": "carrot o' gold",
  "block.minecraft.skeleton_skull": "bag o' bones skull",
  "block.minecraft.wither_skeleton_skull": "corrupted bag o' bones skull",
  "block.minecraft.player_head": "sailor skull",
  "block.minecraft.zombie_head": "undead sailor skull",
  "block.minecraft.creeper_head": "creeper skull",
  "block.minecraft.dragon_head": "wyvern skull",
  "item.minecraft.carrot_on_a_stick": "stick o' carrot",
  "item.minecraft.warped_fungus_on_a_stick": "bafflin' toadstool on a stick",
  "item.minecraft.nether_star": "star o' nether",
  "item.minecraft.pumpkin_pie": "roasted gourd",
  "item.minecraft.firework_rocket": "bomb o' spark'ls",
  "item.minecraft.firework_star": "bomb o' stars",
  "item.minecraft.enchanted_book": "magic book",
  "item.minecraft.nether_brick": "brick o' nether",
  "item.minecraft.quartz": "white rock",
  "item.minecraft.tnt_minecart": "powder keg in a landlubbers' boat",
  "item.minecraft.hopper_minecart": "suckin' device in a landlubbers' boat",
  "item.minecraft.prismarine_shard": "shard o' prismarine",
  "item.minecraft.prismarine_crystals": "crystals o' prismarine",
  "item.minecraft.rabbit": "raw rabbit",
  "item.minecraft.cooked_rabbit": "cooked rabbit",
  "item.minecraft.rabbit_stew": "stew o' rabbit",
  "item.minecraft.rabbit_foot": "foot o' rabbit",
  "item.minecraft.rabbit_hide": "hide o' rabbit",
  "item.minecraft.armor_stand": "booty rack",
  "item.minecraft.iron_horse_armor": "brumby armor o' steel",
  "item.minecraft.golden_horse_armor": "brumby armor o' gold",
  "item.minecraft.diamond_horse_armor": "bejeweled brumby armor",
  "item.minecraft.leather_horse_armor": "brumby armor o' leather",
  "item.minecraft.lead": "rope",
  "item.minecraft.name_tag": "name yer mate",
  "item.minecraft.command_block_minecart": "order block in a landlubbers' boat",
  "item.minecraft.mutton": "raw meat o' sheep",
  "item.minecraft.cooked_mutton": "cooked meat o' sheep",
  "block.minecraft.white_banner": "white flag",
  "block.minecraft.orange_banner": "orange flag",
  "block.minecraft.magenta_banner": "light purple flag",
  "block.minecraft.light_blue_banner": "light blue flag",
  "block.minecraft.yellow_banner": "yellow flag",
  "block.minecraft.lime_banner": "light green flag",
  "block.minecraft.pink_banner": "pink flag",
  "block.minecraft.gray_banner": "gray flag",
  "block.minecraft.light_gray_banner": "light gray flag",
  "block.minecraft.cyan_banner": "ocean blue flag",
  "block.minecraft.purple_banner": "purple flag",
  "block.minecraft.blue_banner": "blue flag",
  "block.minecraft.brown_banner": "brown flag",
  "block.minecraft.green_banner": "green flag",
  "block.minecraft.red_banner": "scarlet flag",
  "block.minecraft.black_banner": "black flag",
  "item.minecraft.end_crystal": "end crystal",
  "item.minecraft.chorus_fruit": "tall one's fruit",
  "item.minecraft.popped_chorus_fruit": "baked tall one's fruit",
  "item.minecraft.beetroot": "bloody potatoes",
  "item.minecraft.beetroot_seeds": "seeds o' bloody potatoes",
  "item.minecraft.beetroot_soup": "soup o' bloody potato",
  "item.minecraft.dragon_breath": "wyvern's breath",
  "item.minecraft.splash_potion": "uncraftable grenade□useless",
  "item.minecraft.spectral_arrow": "magic bolt",
  "item.minecraft.tipped_arrow": "uncraftable tipped bolt□useless",
  "item.minecraft.lingering_potion": "uncraftable bottled fog□useless",
  "item.minecraft.shield": "targe",
  "item.minecraft.elytra": "icarus's wings",
  "item.minecraft.spruce_boat": "vessel o' spruce",
  "item.minecraft.birch_boat": "vessel o' birch",
  "item.minecraft.jungle_boat": "vessel o' jungle",
  "item.minecraft.acacia_boat": "vessel o' acacia",
  "item.minecraft.dark_oak_boat": "vessel o' dusky oak",
  "item.minecraft.totem_of_undying": "jewel o' life",
  "item.minecraft.shulker_shell": "shulker shell",
  "item.minecraft.iron_nugget": "doubloon o' steel",
  "item.minecraft.knowledge_book": "tome o' intellect",
  "item.minecraft.debug_stick": "debug stick",
  "item.minecraft.music_disc_13": "shanty□c418 - 13",
  "item.minecraft.music_disc_cat": "shanty□c418 - cat",
  "item.minecraft.music_disc_blocks": "shanty□c418 - blocks",
  "item.minecraft.music_disc_chirp": "shanty□c418 - chirp",
  "item.minecraft.music_disc_far": "shanty□c418 - far",
  "item.minecraft.music_disc_mall": "shanty□c418 - mall",
  "item.minecraft.music_disc_mellohi": "shanty□c418 - mellohi",
  "item.minecraft.music_disc_stal": "shanty□c418 - stal",
  "item.minecraft.music_disc_strad": "shanty□c418 - strad",
  "item.minecraft.music_disc_ward": "shanty□c418 - ward",
  "item.minecraft.music_disc_11": "shanty□c418 - 11",
  "item.minecraft.music_disc_wait": "shanty□c418 - wait",
  "item.minecraft.music_disc_pigstep": "shanty□lena raine - pigstep",
  "item.minecraft.trident": "poseidon's fightn' fork□□if in yer main hook:□+8 attack damage□-2.9 fastness o' attack",
  "item.minecraft.phantom_membrane": "membrane o' th' flying devil",
  "item.minecraft.nautilus_shell": "sea beast's shell",
  "item.minecraft.heart_of_the_sea": "heart o' th' seas",
  "item.minecraft.crossbow": "crossbow",
  "item.minecraft.suspicious_stew": "fishy gruel",
  "block.minecraft.loom": "sewin' station",
  "item.minecraft.flower_banner_pattern": "flag pattern□flower charge",
  "item.minecraft.creeper_banner_pattern": "flag pattern□creeper charge",
  "item.minecraft.skull_banner_pattern": "flag pattern□skull charge",
  "item.minecraft.mojang_banner_pattern": "flag pattern□thing",
  "item.minecraft.globe_banner_pattern": "flag pattern□globe",
  "item.minecraft.piglin_banner_pattern": "flag pattern□snout",
  "block.minecraft.composter": "rottin' box",
  "block.minecraft.barrel": "barrrel",
  "block.minecraft.smoker": "galley oven",
  "block.minecraft.blast_furnace": "blast oven",
  "block.minecraft.cartography_table": "cap'n's mappin' desk",
  "block.minecraft.fletching_table": "stick sharp'n table",
  "block.minecraft.grindstone": "smithin' rock",
  "block.minecraft.lectern": "readin' stand",
  "block.minecraft.smithing_table": "forgin' bench",
  "block.minecraft.stonecutter": "pebble chopp'r",
  "block.minecraft.bell": "landlubbers' nightmare",
  "block.minecraft.lantern": "lantarrrn",
  "block.minecraft.soul_lantern": "siren's latern",
  "item.minecraft.sweet_berries": "land capers",
  "block.minecraft.campfire": "campfire",
  "block.minecraft.soul_campfire": "campfire o' agony",
  "block.minecraft.shroomlight": "spore o' glowin'",
  "item.minecraft.honeycomb": "treasure o' bee",
  "block.minecraft.bee_nest": "crow's nest o' bee",
  "block.minecraft.beehive": "vessel o' bee",
  "item.minecraft.honey_bottle": "bottle o' nectar",
  "block.minecraft.honey_block": "cube o' bee nectar",
  "block.minecraft.honeycomb_block": "cube o' bee treasure",
  "block.minecraft.lodestone": "wayfindin' rock",
  "block.minecraft.netherite_block": "chunk o' blackbeard's alloy",
  "block.minecraft.ancient_debris": "treasure o' davy jones",
  "block.minecraft.target": "dartboard",
  "block.minecraft.crying_obsidian": "rock o' true sobbin'",
  "block.minecraft.blackstone": "black rock",
  "block.minecraft.blackstone_slab": "slab o' rock o' black",
  "block.minecraft.blackstone_stairs": "stairs o' rock o' black",
  "block.minecraft.gilded_blackstone": "shiny rock o' black",
  "block.minecraft.polished_blackstone": "good lookin' rock o' black",
  "block.minecraft.polished_blackstone_slab": "slab o' good lookin' black rock",
  "block.minecraft.polished_blackstone_stairs": "stairs o' good lookin' black rock",
  "block.minecraft.chiseled_polished_blackstone": "good look'n carv'd rock o' black",
  "block.minecraft.polished_blackstone_bricks": "good lookin' bricks o' rock o' black",
  "block.minecraft.polished_blackstone_brick_slab": "good lookin' slab o' bricks o' rock o' black",
  "block.minecraft.polished_blackstone_brick_stairs": "good lookin' stairs o' bricks o' rock o' black",
  "block.minecraft.cracked_polished_blackstone_bricks": "cracked bricks o' rock o' black",
  "block.minecraft.respawn_anchor": "rebirthin' relic",
}
export const en_pt = items; 
